/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/* prettier-ignore */


export interface PaymentDto {
    id: number;
    userId: number;
    type: PaymentDto.type;
    amount: number;
    credits: number;
    currency?: PaymentDto.currency;
    status: PaymentDto.status;
    reference?: string;
    meta?: any;
    createdAt?: string;
}

export namespace PaymentDto {

    export enum type {
        PAYPAL = 'paypal',
        STRIPE = 'stripe',
    }

    export enum currency {
        EUR = 'eur',
        USD = 'usd',
    }

    export enum status {
        PENDING = 'pending',
        COMPLETED = 'completed',
        REDEEMED = 'redeemed',
        REJECTED = 'rejected',
        APPROVED = 'approved',
        SAVED = 'saved',
        CREATED = 'created',
    }


}



// WEBPACK FOOTER //
// ./src/services/openapi/generated/models/PaymentDto.ts